/* This file is auto-generated by pitspy, it was last generated: 2024-02-22T15:29:07.168517 */


export enum InvalidTokenReason {
	NO_ERROR = 0,
	EXPIRED,
	MISSING,
	USED,
	FOR_DIFFERENT_ACCOUNT
}

export enum BoardState {
	DRAFT = 0,
	OPEN,
	CLOSED,
	ARCHIVED
}

export enum MemberInviteStatus {
	NA = 0,
	INVITED,
	REGISTERED
}

export enum BoardUserRole {
	OWNER = 0,
	EDITOR,
	PARTICIPANT
}

export enum RoleChoice {
	ADMIN = 'admin',
	MEMBER = 'member',
	PARTICIPANT = 'participant'
}

export enum BoardShareMode {
	RESTRICTED = 0,
	LINK
}

export declare type InviteTokenResponse = {
	valid: boolean;
	reason: InvalidTokenReason;
	email: string | null;
	userExists: boolean;
};

export declare type UserType = {
	email: string;
	firstName: string;
	lastName: string;
	uuid: string;
	color: string;
	role: RoleChoice;
	isRegistered: boolean;
	isActive: boolean;
	hasPassword: boolean;
	avatar: string | null;
};

export declare type NotificationSettingsType = {
	productUpdates: boolean;
};

export declare type BoardPublicType = {
	name: string;
	uuid: string;
	emoji: string | null;
};

export declare type BoardType = {
	name: string;
	creator: UserType;
	uuid: string;
	emoji: string | null;
	url: string;
	state: BoardState;
	shareMode: BoardShareMode;
	createdAt: string;
	updatedAt: string;
};

export declare type BoardInfoType = BoardType & {
	configuration: BoardConfigurationType;
	canEdit: boolean;
};

export declare type BoardViewType = BoardInfoType & {
	members: Array<UserType>;
};

export declare type BoardAdminType = BoardInfoType & {
	cardCount: number;
	voteCount: number;
	participantsCount: number;
};

export declare type BoardForUserAdminType = BoardInfoType & {
	cardCount: number;
	voteCount: number;
	commentCount: number;
	role: BoardUserRole;
};

export declare type BoardConfigurationType = {
	cardLimit: number;
	voteLimit: number;
	hideCards: boolean;
	hideVotes: boolean;
	hideCardAuthors: boolean;
	comments: boolean;
	anonymousCards: boolean;
	closeDate: string | null;
	showActiveUsers: boolean;
	introText: string | null;
	introTitle: string | null;
	introRenderedText: string | null;
	welcomeScreenEnabled: boolean;
};

export declare type BoardColumnType = {
	name: string;
	creator: UserType | null;
	index: number;
	uuid: string;
	emoji: string | null;
};

export declare type CardType = {
	text: string;
	renderedText: string;
	index: number;
	uuid: string;
	creator: UserType;
	column: BoardColumnType;
	createdAt: string;
	updatedAt: string;
	votes: Array<[string, string]>;
	comments: Array<CardCommentType>;
	reactions: Array<CardReactionType>;
	linkPreviews: Array<CardLinkPreviewType>;
};

export declare type CardReactionType = {
	emoji: string;
	users: Array<UserType>;
	count: number;
	reactedOn: string;
};

export declare type CardLinkPreviewType = {
	id: number;
	url: string;
	siteName: string | null;
	title: string | null;
	description: string | null;
	image: string | null;
	contentType: string;
	videoType: string | null;
	videoUrl: string | null;
};

export declare type CardCommentType = {
	text: string;
	renderedText: string;
	uuid: string;
	author: UserType;
	createdAt: string;
	updatedAt: string;
	cardUuid: string;
};

export declare type BoardMemberType = {
	user: UserType;
	cards: number;
	votes: number;
	inviteStatus: MemberInviteStatus;
	role: BoardUserRole;
};

export declare type WorkspaceType = {
	name: string;
	subdomain: string;
	avatar: string | null;
	uuid: string;
	url: string;
};

export declare type WorkspaceSearchResultsType = {
	users: Array<UserType>;
	boards: Array<BoardType>;
};

export declare type WorkspaceNotificationSettingsType = {
	boardActivity: boolean;
	cardActivity: boolean;
};

export declare type UploadedFileType = {
	url: string;
	uploaded: UserType | null;
	uuid: string;
};
